<template>
  <Card class="card" v-show="!equipmentDraw">
    <template #title>
      Equipment
      <div style="display: flex; justify-content: center">
        <p class="p-component" style="margin-bottom: -1px; margin-top: 10px">
          On the left sidebar, click on a zone. Click on a construction work name, then an activity name. Fill in the information to add equipment.
        </p>
        <Button
          icon="pi pi-times"
          class="p-button-rounded p-button-secondary p-button-text"
          aria-label="Close"
          style="position: fixed; right: 10px"
          @click="confirmClose()"
        />
      </div>
    </template>
    <template #content>
      <div class="formgrid grid contentPanel">
        <ScrollPanel class="field col-12 md:col-2" style="height: 100%">
          <PanelMenu :model="taskTree" id="taskTree" v-model:expanded-keys="expandedKeys"> </PanelMenu>
        </ScrollPanel>
        <ScrollPanel class="field col-12 md:col-10" style="height: 100%">
          <div class="formgrid grid" v-if="selectedTask != null">
            <h4 class="field col-12 fieldLabel">
              {{ selectedTaskObject.name }} : {{ getDateString(selectedTaskObject.start) }} - {{ getDateString(selectedTaskObject.end) }}
            </h4>
            <div class="formgrid grid" style="width: 100%" v-if="!project.readonly">
              <div class="field col-12 md:col-4 fieldLabel">
                <label class="pr-2">Exclusive Groups</label
                ><i
                  class="pi pi-question-circle"
                  v-tooltip="'Equipment in different exclusive group will operate in periods that do not overlap.'"
                ></i>
              </div>
              <Dropdown
                class="field col-12 md:col-5 fieldLabel"
                v-model="selectedExclusiveGroup"
                :options="exclusiveGroups"
                :editable="true"
                placeholder="Select an Exclusive Group or Add New Exclusive Group"
                @change="newEquipment[0].exclusiveGroup = selectedExclusiveGroup"
                @blur="newEquipment[0].exclusiveGroup = selectedExclusiveGroup"
              />

              <div class="field col-12 md:col-3 fieldLabel">
                <Button
                  :label="
                    selectedExclusiveGroup == 'Without Exclusive Group - included in all groups' || selectedExclusiveGroup == ''
                      ? 'Remove selection from exclusive group'
                      : `Move selection to ${selectedExclusiveGroup}`
                  "
                  icon="pi pi-upload"
                  @click="changeExclusiveGroup"
                  style="float: right"
                  :disabled="selectedEquipments.length == 0"
                  :filter="true"
                ></Button>
              </div>
              <div class="field col-12 md:col-4 fieldLabel">
                <label class="pr-2">Import Default Equipment for Construction Works or Activity</label
                ><i class="pi pi-question-circle" v-tooltip="'Input or select construction works or activities to import relevant equipment​.'"></i>
              </div>
              <Dropdown
                class="field col-12 md:col-5 fieldLabel"
                v-model="selectedActivity"
                :filter="true"
                :options="activityOptions"
                optionGroupLabel="label"
                optionGroupChildren="items"
                optionLabel="name"
                placeholder="Select Suitable Contruction Work or Activity"
                style="height: 30px"
              >
                <template #option="slotProps">
                  <div
                    style="width: 100%"
                    v-tooltip.left="
                      slotProps.option.equipments.length > 1
                        ? slotProps.option.equipments.reduce(function (a, b) {
                            return (a.pme || a) + '\n' + b.pme;
                          })
                        : slotProps.option.equipments.length > 0
                        ? slotProps.option.equipments[0].pme
                        : 'No Default Equipment'
                    "
                  >
                    {{ slotProps.option.name }}
                  </div>
                </template>
              </Dropdown>
              <div class="field col-12 md:col-3 fieldLabel">
                <Button
                  label="Import"
                  icon="pi pi-download"
                  @click="importEquipment"
                  style="float: right; width: 150px"
                  :disabled="selectedActivity == null"
                ></Button>
              </div>
              <div class="field col-12 md:col-4 fieldLabel">
                <label class="pr-2">Import Equipment from other Activities</label
                ><i class="pi pi-question-circle" v-tooltip="'Select an activity to import equipments from it​.'"></i>
              </div>
              <Dropdown
                class="field col-12 md:col-5 fieldLabel"
                v-model="selectedZoneActivity"
                :options="project.tasks"
                optionLabel="optionLabel"
                placeholder="Select an Activity"
                style="height: 30px"
                :filter="true"
              >
              </Dropdown>
              <div class="field col-12 md:col-3 fieldLabel">
                <Button
                  label="Import"
                  icon="pi pi-download"
                  @click="importEquipmentFromActivity"
                  style="float: right; width: 150px"
                  :disabled="selectedZoneActivity == null"
                ></Button>
              </div>
              <div class="field col-12 md:col-4 fieldLabel">
                <label class="pr-2">Copy Equipment to other Activities</label
                ><i class="pi pi-question-circle" v-tooltip="'Select activities to copy equipments to​.'"></i>
              </div>
              <MultiSelect
                class="field col-12 md:col-5 fieldLabel"
                v-model="selectedZoneActivities"
                :options="project.tasks"
                optionLabel="optionLabel"
                placeholder="Select Activities"
                style="height: 30px; line-height: 20px"
                :filter="true"
              >
              </MultiSelect>
              <div class="field col-12 md:col-3 fieldLabel">
                <Button
                  label="Copy"
                  icon="pi pi-copy"
                  @click="confirmOverwriteEquipment"
                  style="float: right; width: 150px"
                  :disabled="selectedZoneActivities.length == 0"
                ></Button>
              </div>
              <div class="field col-12 md:col-4 fieldLabel">
                <label class="pr-2">Import Equipment from CSV</label
                ><i class="pi pi-question-circle" v-tooltip="'Import equipment for current task by uploading CSV template'"></i>
              </div>
              <div class="field col-12 md:col-5 fieldLabel">
                <Button label="Download Template" icon="pi pi-download" @click="downloadTemplate" style="float: right"></Button>
              </div>
              <div class="field col-12 md:col-3 fieldLabel">
                <UploadFile
                  @upload="importTemplate"
                  label="Upload Template"
                  format=".csv"
                  style="float: right; width: 150px"
                  id="uploadEquipment"
                  multiple=""
                >
                </UploadFile>
              </div>
            </div>
          </div>
          <div v-if="selectedTask != null">
            <p>
              Click the <i class="pi pi-list"> icon</i> on the right of the equipment text box to add a new equipment. Click the Save button once
              finished.
            </p>
          </div>
          <div v-if="selectedTask == null && filteredEquipments.length === 0">
            <p>
              On the left sidebar, click on a zone. Click on a construction work name, then an activity name. Fill in the information to add
              equipment.
            </p>
            <p>The construction work name might be blank, click to expand it regardless.</p>
          </div>
          <DataTable
            v-else-if="!project.readonly"
            :value="filteredEquipments"
            :frozenValue="newEquipment"
            filterDisplay="menu"
            :globalFilterFields="['activities']"
            class="p-datatable-sm"
            id="equipmentInput"
            :rowGroupMode="exclusiveGroups.length > 1 ? 'subheader' : null"
            :groupRowsBy="exclusiveGroups.length > 1 ? 'exclusiveGroup' : null"
            :expandableRowGroups="exclusiveGroups.length > 1"
            v-model:expandedRowGroups="expandedRowGroups"
            v-model:selection="selectedEquipments"
          >
            <Column v-if="exclusiveGroups.length > 1" field="exclusiveGroup" header="Exclusive Group" style="min-width: 100px"> </Column>
            <template #groupheader="slotProps">
              <span style="font-weight: bold">
                {{ slotProps.data.exclusiveGroup == "" ? "Without Exclusive Group - included in all groups" : slotProps.data.exclusiveGroup }}
              </span>
            </template>
            <Column v-if="selectedTask != '' && exclusiveGroups.length > 1" selectionMode="multiple" headerStyle="width:30px"> </Column>
            <Column field="pme" header="Equipment" frozen :sortable="true">
              <template #body="slotProps">
                <label
                  v-if="!newEquipment.includes(slotProps.data)"
                  v-tooltip="
                    [
                      project.zones.filter((z) => z.id == slotProps.data.zone)[0].name,
                      slotProps.data.group,
                      project.tasks.filter((t) => t.id == slotProps.data.task)[0].name,
                    ]
                      .filter((t) => t != '' && t != '-')
                      .join(' > ')
                  "
                  >{{ slotProps.data.pme }}</label
                >
                <div v-else class="formgrid grid" style="width: 110%">
                  <!-- <InputText v-model="slotProps.data.pme" style="margin:5px 0; height:30px;"
                                            @complete="updateTaskTreeStatus(slotProps.data)"
                                            class="field col-12 md:col-9" /> -->
                  <AutoComplete
                    v-model="slotProps.data.pme"
                    @complete="searchAutoCompletePME($event)"
                    @item-select="selectAutoCompletePME($event)"
                    :dropdown="true"
                    class="field col-12 md:col-9"
                    style="margin: 5px 0; height: 30px; max-width: 400px"
                    :suggestions="filteredPMEs"
                    aria-label="Equipment"
                    v-tooltip="'Input equipment name by selecting from the list or input manually'"
                  >
                  </AutoComplete>
                  <Button
                    icon="pi pi-list"
                    class="field col-12 md:col-3"
                    @click="showEquipmentList = true"
                    style="margin: 5px 0; height: 30px; width: 30px"
                    aria-label="Search or select equipment from equipment list"
                    v-tooltip="'Search or select equipment from equipment list'"
                  />
                </div>
              </template>
            </Column>
            <Column field="quantity" header="Quantity" style="width: 80px" :sortable="true">
              <template #body="slotProps">
                <InputNumber
                  v-model="slotProps.data.quantity"
                  aria-label="Quantity"
                  :min="0"
                  :max="1000"
                  class="inputnumber"
                  style="width: 100%"
                  @input="updateTaskTreeStatus(slotProps.data)"
                />
              </template>
            </Column>
            <Column field="noisePower" header="Sound Power" style="width: 110px" :sortable="true">
              <template #body="slotProps">
                <label v-if="slotProps.data.pme.includes('CNP')">{{ slotProps.data.noisePower }}</label>
                <div v-else class="formgrid grid" style="width: 120%">
                  <InputNumber
                    v-model="slotProps.data.noisePower"
                    :min="slotProps.data.noisePowerMin"
                    :max="slotProps.data.noisePowerMax"
                    class="field col-12 md:col-8"
                    @input="updateTaskTreeStatus(slotProps.data)"
                    style="margin: 0px; padding: 0 5px 0 0"
                    aria-label="Sound Power"
                    v-tooltip="slotProps.data.defaultNoisePower ? `Default: ${slotProps.data.defaultNoisePower}` : 'No default sound power'"
                    showButtons
                  />
                  <Button
                    v-if="slotProps.data.noisePower != slotProps.data.defaultNoisePower"
                    icon="pi pi-upload"
                    class="field col-12 md:col-3"
                    @click="
                      showUploadDialog = true;
                      selectedEquipment = slotProps.data;
                    "
                    aria-label="Upload support materials"
                    style="margin: 0px"
                    v-tooltip="'Upload support materials'"
                  />
                </div>
              </template>
            </Column>
            <Column field="startDate" header="Start Date" style="width: 130px" :sortable="true">
              <template #body="slotProps">
                <Calendar
                  v-model="slotProps.data.startDate"
                  :showIcon="true"
                  class="w-full inputnumber"
                  @date-select="updateTaskTreeStatus(slotProps.data)"
                  :minDate="getStartDate(slotProps.data)"
                  :maxDate="getEndDate(slotProps.data)"
                  dateFormat="yy-mm-dd"
                  aria-label="Start Date"
                />
              </template>
            </Column>
            <Column field="endDate" header="End Date" style="width: 130px" :sortable="true">
              <template #body="slotProps">
                <Calendar
                  v-model="slotProps.data.endDate"
                  :showIcon="true"
                  class="w-full inputnumber"
                  @date-select="updateTaskTreeStatus(slotProps.data)"
                  :minDate="getStartDate(slotProps.data)"
                  :maxDate="getEndDate(slotProps.data)"
                  dateFormat="yy-mm-dd"
                  aria-label="End Date"
                />
              </template>
            </Column>
            <Column field="timePercent" header="% on Time in 30 mins" style="width: 130px" :sortable="true">
              <template #body="slotProps">
                <InputNumber
                  v-model="slotProps.data.timePercent"
                  :min="slotProps.data.percentMin || 10"
                  :max="100"
                  suffix="%"
                  class="inputnumber"
                  aria-label="% on Time in 30 mins"
                  @input="updateTaskTreeStatus(slotProps.data)"
                  showButtons
                />
              </template>
            </Column>
            <Column field="location" header="Location" style="max-width: 150px" :sortable="true">
              <template #body="slotProps">
                <div class="formgrid grid" style="width: 125%">
                  <Dropdown
                    v-model="slotProps.data.location"
                    :options="locationOptions"
                    optionLabel="label"
                    optionValue="value"
                    class="field col-12 md:col-7"
                    :onChange="locationChange(slotProps)"
                    style="margin: 5px 0; height: 30px"
                  />
                  <Button
                    v-if="slotProps.data.location === 'Fixed Location'"
                    icon="pi pi-pencil"
                    class="field col-12 md:col-2"
                    @click="
                      isclicked = true;
                      locationChange(slotProps);
                      equipmentDraw = true;
                    "
                    style="margin: 5px"
                  />
                </div>
              </template>
            </Column>
            <Column header="" style="width: 40px">
              <template #body="slotProps">
                <Button
                  v-if="!newEquipment.includes(slotProps.data)"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-secondary p-button-text p-button-danger"
                  aria-label="Delete"
                  @click="deleteEquipment(slotProps.data)"
                  v-tooltip="'Delete'"
                />
                <Button
                  v-else
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-secondary p-button-text p-button-success"
                  @click="addnewEquipment(slotProps.data)"
                  v-tooltip="'Add'"
                  aria-label="Add new equipment"
                  :disabled="slotProps.data.pme === ''"
                />
              </template>
            </Column>
          </DataTable>
          <DataTable
            v-else
            :value="filteredEquipments"
            filterDisplay="menu"
            :globalFilterFields="['activities']"
            class="p-datatable-sm"
            id="equipmentInput"
          >
            <Column field="pme" header="Equipment" frozen :sortable="true"> </Column>
            <Column field="quantity" header="Quantity" style="width: 80px" :sortable="true"> </Column>
            <Column field="noisePower" header="Sound Power" style="width: 110px" :sortable="true">
              <template #body="slotProps">
                <div class="formgrid grid" style="width: 100%">
                  <label class="field col-12 md:col-8" style="margin: 0px">{{ slotProps.data.noisePower }}</label>
                  <Button
                    v-if="slotProps.data.noisePower != slotProps.data.defaultNoisePower"
                    icon="pi pi-upload"
                    class="field col-12 md:col-4"
                    @click="
                      showUploadDialog = true;
                      selectedEquipment = slotProps.data;
                    "
                    style="margin: 0px"
                    v-tooltip="'Upload support materials'"
                  />
                </div>
              </template>
            </Column>
            <Column field="startDate" header="Start Date" style="width: 130px" :sortable="true"> </Column>
            <Column field="endDate" header="End Date" style="width: 130px" :sortable="true"> </Column>
            <Column field="timePercent" header="% on Time in 30 mins" style="width: 130px" :sortable="true"> </Column>
            <Column field="location" header="Location" style="max-width: 150px" :sortable="true"> </Column>
            <Column header="" style="width: 40px"> </Column>
          </DataTable>
        </ScrollPanel>
      </div>
    </template>
    <template #footer>
      <div class="formgrid grid" v-if="!project.readonly">
        <div class="field col-8"></div>
        <div class="field col-2">
          <Button label="Save" :icon="saving1" style="width: 100%" @click="save(false)" :disabled="saving" />
        </div>
        <div class="field col-2">
          <Button label="Save & Close" :icon="saving2" style="float: right; width: 100%" @click="save(true)" :disabled="saving" />
        </div>
      </div>
    </template>
  </Card>
  <Card class="card" v-show="showEquipmentList">
    <template #title>
      Equipment List
      <Button
        icon="pi pi-times"
        class="p-button-rounded p-button-secondary p-button-text"
        style="position: fixed; right: 10px"
        @click="
          showEquipmentList = false;
          searchPME = '';
          search();
        "
      />
    </template>
    <template #content>
      <ScrollPanel class="contentPanel">
        <div class="formgrid grid">
          <div class="col-12 md:col-11">
            <span class="p-input-icon-left" style="width: 100%">
              <i class="pi pi-search" />
              <InputText v-model="searchPME" placeholder="Search" @input="search" style="width: 100%"> </InputText>
            </span>
          </div>
          <div class="col-12 md:col-1">
            <Button
              icon="pi pi-refresh"
              label="Reset"
              style="float: right"
              @click="
                selectedPMEs = [];
                selectedQPMEs = [];
                searchPME = '';
                search();
              "
              v-tooltip="'Clear all selection'"
            >
            </Button>
          </div>
        </div>
        <h4>PME</h4>
        <Listbox v-model="selectedPMEs" :options="searchedPMEs" multiple="multiple" id="pmeList" @change="setCurrentSelect">
          <template #option="slotProps">
            <div
              class="col-12 md:col-4"
              style="width: 100%; display: flex; align-items: center; height: 30px"
              v-tooltip.bottom="`Sound Power: ${slotProps.option.noisePower}`"
            >
              <span style="display: block; text-align: left">{{ slotProps.option.pme }}</span>
            </div>
          </template>
        </Listbox>
        <!-- <h4>QPME</h4>
                <Listbox v-model="selectedQPMEs" :options="searchedQPMEs" multiple="multiple" id="qpmeList"
                    @change="setCurrentSelect">
                    <template #option="slotProps">
                        <div class="col-12 md:col-4" style="width:100%;display: flex;align-items: center;height: 30px;"
                            v-tooltip="`Sound Power: ${slotProps.option.noisePower}`">
                            <span style="display: block;text-align: left;">{{ slotProps.option.pme
                            }}</span>
                        </div>
                    </template>
                </Listbox> -->
      </ScrollPanel>
    </template>
    <template #footer>
      <div class="formgrid grid">
        <div class="field col-12">
          <Button label="Add" icon="pi pi-plus" style="float: right" @click="addnewEquipments" />
        </div>
      </div>
    </template>
  </Card>
  <Card class="card" v-if="showUploadDialog">
    <template #title>
      Support Materials
      <Button
        icon="pi pi-times"
        class="p-button-rounded p-button-secondary p-button-text"
        style="position: fixed; right: 10px"
        @click="showUploadDialog = false"
      />
    </template>
    <template #content>
      <div style="text-align: left">Please upload support materials for user defined sound power:</div>
      <SupportMaterialTable
        :equipments="filteredEquipments.filter((fe) => fe.defaultNoisePower != fe.noisePower)"
        :project="project"
        :disabled="project.readonly"
        mode="pme"
      >
      </SupportMaterialTable>
    </template>
  </Card>
  <Card class="card" v-if="showRequiredPMEDialog && currentSelected != null && currentSelected.required1.length > 0">
    <template #title>
      Required Equipment
      <Button
        icon="pi pi-times"
        class="p-button-rounded p-button-secondary p-button-text"
        style="position: fixed; right: 10px"
        @click="
          showRequiredPMEDialog = false;
          currentSelected = null;
        "
      />
    </template>
    <template #content>
      <div style="text-align: left">Please select required equipment when using {{ currentSelected.pme }}:</div>
      <div class="formgrid grid">
        <template v-for="index in ['1', '2', '3']">
          <div class="col-12 md:col-4">
            <div style="text-align: left; margin: 20px 0px 5px 0px">
              {{ index == "1" ? "First" : index == "2" ? "Second" : "Third" }} Required Equipment
            </div>
            <Listbox
              v-model="$data['selectedRequired' + index]"
              :options="currentSelected['required' + index]"
              :emptyMessage="'----------------------------------------------------------'"
            >
              <template #option="slotProps">
                <span style="display: block; text-align: left" v-tooltip="`Sound Power: ${slotProps.option.noisePower}`">{{
                  slotProps.option.pme
                }}</span>
              </template>
            </Listbox>
          </div>
        </template>
      </div>
    </template>
    <template #footer>
      <div class="formgrid grid">
        <div class="field col-12">
          <Button label="Add" icon="pi pi-plus" style="float: right" @click="addRequiredEquipments(fromAutoComplete)" />
        </div>
      </div>
    </template>
  </Card>
  <div class="minimize" v-if="equipmentDraw">
    <Card style="height: 14vh">
      <template #title>
        Define Equipment Fixed Location
        <Button
          icon="pi pi-window-maximize"
          class="p-button-rounded p-button-secondary p-button-text"
          style="position: fixed; right: 10px"
          @click="closeEqpDraw"
        />
      </template>
    </Card>
  </div>
  <ConfirmPopup></ConfirmPopup>
</template>

<script>
import MapOL from "@/libs/myOpenLayers.js";
import DateHelper from "@/helper/DateHelper";
import SupportMaterialTable from "@/components/report module/SupportMaterialTable.vue";
import UploadFile from "@/components/UploadFile.vue";
import Papa from "papaparse";

export default {
  components: {
    SupportMaterialTable,
    UploadFile,
  },
  data() {
    return {
      project: this.getCurrentProject(),
      taskTree: [],
      expandedKeys: {},
      selected: null,
      filteredEquipments: [],
      newEquipment: [],
      newEquipmentAutoComplete: {},

      showEquipmentList: false,
      searchPME: "",
      pmes: [],
      searchedPMEs: [],
      searchedQPMEs: [],
      selectedPMEs: [],
      selectedQPMEs: [],
      filteredPMEs: [],
      fromAutoComplete: false,
      selectedEquipments: [], //from changing exclusive group

      showRequiredPMEDialog: false,
      currentSelected: null,
      selectedRequired1: null,
      selectedRequired2: null,
      selectedRequired3: null,

      showUploadDialog: false,
      selectedEquipment: null,

      constructionWorks: [],
      activities: [],
      columns: [
        { name: "activities", text: "Activities", format: "label" },
        { name: "pme", text: "pme", format: "label" },
        { name: "timePercent", text: "Time %", format: "textboxnumberrange" },
        { name: "quantity", text: "Qty", format: "textboxnumber" },
        { name: "noisePower", text: "SWL dB(A)", format: "textboxnumber" },
        { name: "startDate", text: "Start Period", format: "date" },
        { name: "endDate", text: "End Period", format: "date" },
        { name: "timePeriod", text: "Time Period", format: "combobox" },
        { name: "location", text: "Location", format: "combobox" },
      ],
      activitiesData: [
        { name: "Earthwork" },
        { name: "Box Culvert Structure" },
        { name: "Bridge Structure" },
        { name: "Noise Barrier Structure" },
        { name: "Paving" },
        { name: "Landscaping" },
        { name: "SPS Foundation" },
        { name: "SPS sub-structure and Superstructure" },
        { name: "Pipe Laying (800m)" },
        { name: "Ancilary Works" },
      ],
      timePeriodOptions: [
        { label: "All days during 1900-2300 hr, and general holiday during 0700-2300 hr.", value: 1 },
        { label: "All days during 2300-0700 hr.", value: 2 },
      ],
      locationOptions: [
        { label: "Notional Source", value: "Notional Source" },
        { label: "Fixed Location", value: "Fixed Location" },
      ],
      timePeriodModel: null,
      activityOptions: [],
      pmeOptions: [],
      selectedZone: null,
      selectedGroup: null,
      selectedTask: null,
      selectedTaskObject: { name: "", start: "", end: "" },
      selectedActivity: null,
      isclicked: false,

      saving: false,
      saving1: "pi pi-save",
      saving2: "pi pi-save",

      equipmentDraw: false,

      exclusiveGroups: ["Without Exclusive Group - included in all groups"],
      selectedExclusiveGroup: "",
      expandedRowGroups: null,

      zoneActivityOptions: [],
      selectedZoneActivity: null,

      selectedZoneActivities: [],

      initialEquipment: [],
      saved: true,
    };
  },
  computed: {
    equipments() {
      return [
        ...new Set([this.constructionWorks.map((cw) => cw.equipments).flat(2), this.activities.map((ac) => ac.equipments).flat(2)].flat()),
      ].sort((a, b) => (a > b ? 1 : -1));
    },
  },
  methods: {
    confirmClose() {
      let props = this;
      if (!props.saved) {
        props.$confirm.require({
          target: event.currentTarget,
          message: "Do you want to close without saving changes?",
          icon: "pi pi-info-circle",
          accept: () => {
            props.close();
          },
          reject: () => {},
        });
      } else {
        props.close();
      }
    },
    close() {
      //MapOL.showPMEEndActions();
      console.log(this.initialEquipment);
      this.project.equipments = [...this.initialEquipment];
      MapOL.clearEquipmentTempLayers();
      this.$router.replace({ path: "/" });
    },
    save(close) {
      let props = this;
      props.saving = true;
      if (close) {
        props.saving2 = "pi pi-spin pi-spinner";
      } else {
        props.saving1 = "pi pi-spin pi-spinner";
      }
      let sortedEquipments = [];
      for (var i = 0; i < props.project.equipments.length; i++) {
        let eq = props.project.equipments[i];
        var duplicate = sortedEquipments.filter(
          (e) =>
            e.zone == eq.zone &&
            e.group == eq.group &&
            e.task == eq.task &&
            e.exclusiveGroup == eq.exclusiveGroup &&
            e.pme == eq.pme &&
            e.noisePower == eq.noisePower &&
            DateHelper.getDateString(e.startDate) == DateHelper.getDateString(eq.startDate) &&
            DateHelper.getDateString(e.endDate) == DateHelper.getDateString(eq.endDate) &&
            e.timePercent == eq.timePercent &&
            e.location !== "Fixed Location",
        );
        if (duplicate.length == 1) {
          duplicate[0].quantity = Number.parseInt(duplicate[0].quantity) + Number.parseInt(eq.quantity);
        } else {
          sortedEquipments.push(eq);
        }
      }
      props.project.equipments = sortedEquipments;
      props.project.equipments.forEach((e) => {
        if (e.isqpme === true) {
          e.otherName = e.pme.includes("CNP") ? e.pme.split("-").slice(1).join("-").trim() : e.pme;
          e.officialId = "";
          e.qpmename = e.pme.includes("CNP") ? e.pme.split("-").slice(1).join("-").trim() : e.pme;
          e.qpmeNoisePower = e.noisePower;
        } else {
          e.otherName = e.pme.includes("CNP") ? e.pme.split("-").slice(1).join("-").trim() : e.pme;
          e.officialId = e.pme.includes("CNP") ? e.pme.split("-")[0].trim() : "";
          e.qpmename = "";
          e.qpmeNoisePower = 0;
        }
        e.startDate = DateHelper.getDateString(e.startDate);
        e.endDate = DateHelper.getDateString(e.endDate);
      });
      console.log("props.project.equipments");
      console.log(props.project.equipments);

      // Split equipment into batches of 5 to avoid payload too large error
      const batchSize = 5;
      const equipmentBatches = [];
      console.log("props.project.equipments.length", props.project.equipments.length);
      for (let i = 0; i < props.project.equipments.length; i += batchSize) {
        equipmentBatches.push(props.project.equipments.slice(i, i + batchSize));
      }
      console.log("equipmentBatches", equipmentBatches);

      // Process batches sequentially
      let allResponses = [];
      const processBatch = async (batchIndex) => {
        if (batchIndex >= equipmentBatches.length) {
          // All batches processed successfully
          console.log("All batches processed", allResponses);
          allResponses.forEach((e) => {
            e.startDate = DateHelper.getDateString(e.startDate);
            e.endDate = DateHelper.getDateString(e.endDate);
          });
          props.project.equipments = allResponses;
          props.initialEquipment = props.project.equipments.map((e) => {
            return { ...e };
          });
          props.saved = true;
          MapOL.saveEquipmentGeometries();
          props.$store.dispatch("setCurrentProject", { project: props.project });
          if (close) {
            props.$router.push("/");
            props.saving2 = "pi pi-save";
          } else {
            props.saving1 = "pi pi-save";
            props.filterEquipment();
          }
          props.saving = false;
          return;
        }

        // Process current batch
        props.axios
          .post(`${props.apiEndpoint}projectpme?projectid=${props.project.id}&isMitigated=0`, equipmentBatches[batchIndex])
          //.post(`https://localhost:44384/projectpme?projectid=${props.project.id}&isMitigated=0`, equipmentBatches[batchIndex])
          .then(function (response) {
            console.log(`Batch ${batchIndex + 1}/${equipmentBatches.length} completed`, response);
            allResponses = allResponses.concat(response.data);
            // Process next batch
            processBatch(batchIndex + 1);
          })
          .catch((error) => {
            console.log(error);
            if (close) {
              props.$router.push("/");
              props.saving2 = "pi pi-save";
            } else {
              props.saving1 = "pi pi-save";
            }
            props.saving = false;
          });
      };

      // Start processing from first batch
      processBatch(0);
    },
    editPMEPosition(pmeIndex) {
      alert(pmeIndex);
    },
    locationChange(slotProp) {
      //console.log(slotProp);
      //console.log(idx);
      // if(event.value === "Fixed Location") {
      //     MapOL.switchOnEquipDraw();
      // }

      if (slotProp.data.location === "Fixed Location") {
        if (this.isclicked === true) {
          MapOL.switchOnEquipDraw(slotProp.data);
          //MapOL.switchOnEquipDraw(slotProp.data.projectPMEId);
          //MapOL.switchOffEquipDraw();
          this.isclicked = false;
        }
      } else {
        MapOL.deleteEquipPointByID(slotProp.data.projectPMEId);
      }
    },
    closeEqpDraw() {
      this.equipmentDraw = false;
      MapOL.switchOffEquipDraw();
    },
    getCurrentProject() {
      return this.$store.getters.currentProject;
    },
    initEquipments() {
      let props = this;
      props.axios
        .get(`${props.apiEndpoint}pme`)
        .then(function (response) {
          props.equipments = response.data;
          let all = [];
          response.data
            .filter((e) => !e.isQCM)
            .forEach((e) => {
              e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
              props.pmes.push(e);
              all.push(e);
            });
          props.pmes.sort((a, b) => (a.pme > b.pme ? 1 : -1));
          props.pmes.forEach((e) => {
            e.required1 = e.required1
              .filter((item) => item)
              .map((id) => all.filter((e) => e.id == id)[0])
              .sort((a, b) => (a.pme > b.pme ? 1 : -1));
            e.required2 = e.required2
              .filter((item) => item)
              .map((id) => all.filter((e) => e.id == id)[0])
              .sort((a, b) => (a.pme > b.pme ? 1 : -1));
            e.required3 = e.required3
              .filter((item) => item)
              .map((id) => all.filter((e) => e.id == id)[0])
              .sort((a, b) => (a.pme > b.pme ? 1 : -1));
          });
          props.searchedPMEs = props.pmes.filter((e) => !e.isQPME && !e.isQCM);
          props.searchedQPMEs = props.pmes.filter((e) => e.isQPME);
          props.filteredPMEs = props.pmes.map((e) => e.pme);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initTaskTree() {
      let props = this;
      props.project.zones
        .sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        )
        .forEach((zone) => {
          let zoneLevel = {
            key: zone.id,
            label: zone.name,
            id: zone.id,
            icon: "",
            command: (event) => {
              // props.expandedKeys[zone.id] = !props.expandedKeys[zone.id];
              props.selectedZone = zone;
              props.selectedGroup = null;
              props.selectedTask = null;
              props.select(event.originalEvent.target);
              props.newEquipment = [];
              props.filterEquipment();
            },
            items: [],
          };
          props.taskTree.push(zoneLevel);
          // props.expandedKeys[zone.id] = true;
        });
      props.project.tasks
        .sort((a, b) => (a.start + a.id > b.start + b.id ? 1 : -1))
        .forEach((task) => {
          let zone =
            props.taskTree.filter((zone) => zone.id == task.zone).length > 0 ? props.taskTree.filter((zone) => zone.id == task.zone)[0] : null;
          if (!zone) return;
          let groups = zone.items.filter((group) => group.label == task.group);
          if (groups.length > 0) {
            groups[0].items.push({
              key: `${zone.id}_${task.group}_${task.id}`,
              label: task.name,
              id: task.id,
              icon: this.getTaskStatus(task.zone, task.group, task.id),
              command: (event) => {
                // props.expandedKeys[`${zone.id}_${task.group}_${task.id}`] = !props.expandedKeys[`${zone.id}_${task.group}_${task.id}`];
                props.selectedZone = zone;
                props.selectedGroup = task.group;
                props.selectedTask = task.id;
                props.selectedTaskObject = task;
                props.select(event.originalEvent.target);
                let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
                props.newEquipment = [
                  {
                    projectactid: maxPMEId + 1,
                    actid: "",
                    activities: "",
                    projectPMEId: maxPMEId + 1,
                    pmeId: "",
                    pme: "",
                    timePercent: 100,
                    quantity: 1,
                    noisePower: "",
                    startDate: DateHelper.getDate(task.start),
                    endDate: DateHelper.getDate(task.end),
                    timePeriod: 1,
                    location: "Notional Source",
                    zone: props.selectedZone.id,
                    group: props.selectedGroup,
                    task: props.selectedTask,
                    isqpme: false,
                    isqcm: false,
                    supportMaterials: [],
                    exclusiveGroup: this.selectedExclusiveGroup,
                  },
                ];
                props.filterEquipment();
              },
            });
            // props.expandedKeys[`${zone.id}_${task.group}_${task.id}`] = true;
          } else {
            zone.items.push({
              key: `${zone.id}_${task.group}`,
              label: task.group,
              icon: "pi pi-pencil",
              command: (event) => {
                // props.expandedKeys[`${zone.id}_${task.group}`] = !props.expandedKeys[`${zone.id}_${task.group}`];
                props.selectedZone = zone;
                props.selectedGroup = task.group;
                props.selectedTask = null;
                props.select(event.originalEvent.target);
                props.newEquipment = [];
                props.filterEquipment();
              },
              items: [
                {
                  key: `${zone.id}_${task.group}_${task.id}`,
                  label: task.name,
                  id: task.id,
                  icon: this.getTaskStatus(task.zone, task.group, task.id),
                  command: (event) => {
                    // props.expandedKeys[`${zone.id}_${task.group}_${task.id}`] = !props.expandedKeys[`${zone.id}_${task.group}_${task.id}`];
                    props.selectedZone = zone;
                    props.selectedGroup = task.group;
                    props.selectedTask = task.id;
                    props.selectedTaskObject = task;
                    props.select(event.originalEvent.target);
                    let maxPMEId =
                      props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
                    props.newEquipment = [
                      {
                        projectactid: maxPMEId + 1,
                        actid: "",
                        activities: "",
                        projectPMEId: maxPMEId + 1,
                        pmeId: "",
                        pme: "",
                        timePercent: 100,
                        quantity: 1,
                        noisePower: "",
                        startDate: DateHelper.getDate(task.start),
                        endDate: DateHelper.getDate(task.end),
                        timePeriod: 1,
                        location: "Notional Source",
                        zone: props.selectedZone.id,
                        group: props.selectedGroup,
                        task: props.selectedTask,
                        isqpme: false,
                        isqcm: false,
                        supportMaterials: [],
                        exclusiveGroup: this.selectedExclusiveGroup,
                      },
                    ];
                    props.filterEquipment();
                  },
                },
              ],
            });
            // props.expandedKeys[`${zone.id}_${task.group}`] = true;
            // props.expandedKeys[`${zone.id}_${task.group}_${task.id}`] = false;
          }
          task.optionLabel = task.group == "-" ? `${zone.label} - ${task.name}` : `${zone.label} - ${task.group} - ${task.name}`;
          props.zoneActivityOptions.push({
            task: task.id,
            name: task.group == "-" ? `${zone.label} - ${task.name}` : `${zone.label} - ${task.group} - ${task.name}`,
          });
        });
      props.taskTree.forEach((z) => {
        z.items.forEach((g) => {
          g.icon = props.getGroupStatus(g.items);
        });
      });
      props.project.tasks.sort((a, b) => (a.optionLabel > b.optionLabel ? 1 : -1));
      props.zoneActivityOptions.sort((a, b) => (a.name > b.name ? 1 : -1));
      console.log(props.taskTree);
    },
    getGroupStatus(taskItems) {
      let completed = true;
      taskItems.forEach((t) => {
        completed = completed && t.icon == "pi pi-check";
      });
      return completed && taskItems.length > 0 ? "pi pi-check" : "pi pi-pencil";
    },
    getTaskStatus(zone, group, task) {
      let props = this;
      let completed = true;
      let equipments = props.project.equipments.filter((eq) => eq.zone == zone && eq.group == group && eq.task == task);
      equipments.forEach((eq) => {
        let isNullUndefEmptyStr =
          eq.quantity == null || eq.noisePower == null || eq.startDate == null || eq.endDate == null || eq.timePercent == null;
        if (isNullUndefEmptyStr) {
          completed = false;
        }
      });
      return completed && equipments.length > 0 ? "pi pi-check" : "pi pi-pencil";
    },
    updateTaskTreeStatus(equipment) {
      console.log("updateTaskTreeStatus", equipment);
      this.saved = false;
      let groupTree = this.taskTree.filter((z) => z.id == equipment.zone)[0].items.filter((g) => g.label == equipment.group)[0];
      let taskItems = groupTree.items.filter((t) => t.id == equipment.task);
      if (taskItems.length > 0) {
        taskItems[0].icon = this.getTaskStatus(equipment.zone, equipment.group, equipment.task);
      }
      groupTree.icon = this.getGroupStatus(taskItems);
    },
    select(element) {
      if (this.selected) {
        this.selected.style.color = "#495057";
      }
      element.style.color = "green";
      this.selected = element;
    },
    expandNode(node) {
      if (node.items && node.items.length) {
        this.expandedKeys[node.key] = true;

        for (let child of node.items) {
          this.expandNode(child);
        }
      }
    },
    getStartDate(equipment) {
      let task = this.project.tasks.filter((t) => t.id == equipment.task);
      if (task.length > 0) {
        return new Date(task[0].start);
      }
    },
    getEndDate(equipment) {
      let task = this.project.tasks.filter((t) => t.id == equipment.task);
      if (task.length > 0) {
        return new Date(task[0].end);
      }
    },
    getDateString(date) {
      return DateHelper.getDateString(date);
    },
    initActivityOptions() {
      this.activityOptions = [
        { label: "Construction Works", items: this.constructionWorks },
        { label: "Activities", items: this.activities },
      ];
    },
    filterEquipment() {
      if (this.selectedGroup != null && this.selectedTask != null) {
        this.filteredEquipments = this.project.equipments
          .filter((e) => e.zone == this.selectedZone.id)
          .filter((e) => e.group == this.selectedGroup)
          .filter((e) => e.task == this.selectedTask)
          .sort((a, b) => (a.exclusiveGroup > b.exclusiveGroup ? 1 : -1));
      } else if (this.selectedGroup != null) {
        this.filteredEquipments = this.project.equipments
          .filter((e) => e.zone == this.selectedZone.id)
          .filter((e) => e.group == this.selectedGroup)
          .sort((a, b) => (a.exclusiveGroup > b.exclusiveGroup ? 1 : -1));
      } else {
        this.filteredEquipments = this.project.equipments
          .filter((e) => e.zone == this.selectedZone.id)
          .sort((a, b) => (a.exclusiveGroup > b.exclusiveGroup ? 1 : -1));
      }
    },
    setCurrentSelect(event) {
      let props = this;
      let filtered = event.value ? event.value.filter((e) => e.pme == event.originalEvent.target.innerText) : [event];
      let equipmentList = props.project.equipments.filter(
        (e) =>
          e.zone == props.selectedZone.id &&
          e.group == props.selectedGroup &&
          e.task == props.selectedTask &&
          e.exclusiveGroup == props.selectedExclusiveGroup,
      );
      if (filtered.length > 0) {
        if (filtered[0].required1.length > 0) {
          this.currentSelected = filtered[0];
          ["1", "2", "3"].forEach((index) => {
            let selected = filtered[0][`required${index}`].filter((e) => equipmentList.filter((e2) => e2.pme == e.pme).length > 0);
            props[`selectedRequired${index}`] = selected.length > 0 ? selected[0] : null;
          });
          if (event.value) {
            event.value.splice(event.value.indexOf(this.currentSelected), 1);
          }
          this.fromAutoComplete = false;
          this.showRequiredPMEDialog = true;
        }
      } else {
        this.currentSelected = null;
      }
    },
    addnewEquipment(equipment) {
      this.project.equipments.push(equipment);
      if (this.selectedExclusiveGroup != "" && !this.exclusiveGroups.includes(this.selectedExclusiveGroup)) {
        this.exclusiveGroups.push(this.selectedExclusiveGroup);
        this.exclusiveGroups.sort();
      }
      // if (this.selectedExclusiveGroup != "") {
      //     this.project.equipments.filter(e =>
      //         e.zone == this.selectedZone.id && e.group == this.selectedGroup && e.task == this.selectedTask && e.exclusiveGroup == ""
      //     ).forEach(e => { e.exclusiveGroup = this.selectedExclusiveGroup })
      // }
      let maxPMEId = this.project.equipments.length == 0 ? 0 : Math.max(...this.project.equipments.map((e) => parseInt(e.projectPMEId)));
      this.newEquipment = [
        {
          projectactid: maxPMEId + 1,
          actid: "",
          activities: "",
          projectPMEId: maxPMEId + 1,
          pmeId: "",
          pme: "",
          timePercent: 100,
          quantity: 1,
          noisePower: "",
          defaultNoisePower: 0,
          startDate:
            this.project.tasks.filter((t) => t.id == this.selectedTask).length > 0
              ? DateHelper.getDate(this.project.tasks.filter((t) => t.id == this.selectedTask)[0].start)
              : null,
          endDate:
            this.project.tasks.filter((t) => t.id == this.selectedTask).length > 0
              ? DateHelper.getDate(this.project.tasks.filter((t) => t.id == this.selectedTask)[0].end)
              : null,
          timePeriod: 1,
          location: "Notional Source",
          zone: this.selectedZone.id,
          group: this.selectedGroup,
          task: this.selectedTask,
          isqpme: false,
          isqcm: false,
          supportMaterials: [],
          exclusiveGroup: this.selectedExclusiveGroup,
        },
      ];
      this.filterEquipment();
      this.updateTaskTreeStatus({
        zone: this.selectedZone.id,
        group: this.selectedGroup,
        task: this.selectedTask,
      });
    },
    addRequiredEquipments(fromAutoComplete) {
      let props = this;
      let equipmentList = props.project.equipments.filter(
        (e) =>
          e.zone == props.selectedZone.id &&
          e.group == props.selectedGroup &&
          e.task == props.selectedTask &&
          e.exclusiveGroup == props.selectedExclusiveGroup,
      );
      ["1", "2", "3"].forEach((index) => {
        if (props[`selectedRequired${index}`]) {
          if (equipmentList.filter((e2) => e2.pme == props[`selectedRequired${index}`].pme).length == 0) {
            if (
              props[`selectedRequired${index}`].isQPME &&
              props.selectedQPMEs.filter((e) => e.id == props[`selectedRequired${index}`].id).length == 0
            ) {
              props.selectedQPMEs.push(props[`selectedRequired${index}`]);
            } else if (props.selectedPMEs.filter((e) => e.id == props[`selectedRequired${index}`].id).length == 0) {
              props.selectedPMEs.push(props[`selectedRequired${index}`]);
            }
          }
        }
        props[`selectedRequired${index}`] = null;
      });
      if (this.currentSelected.isQPM) {
        this.selectedQPMEs.push(this.currentSelected);
      } else {
        this.selectedPMEs.push(this.currentSelected);
      }
      if (fromAutoComplete) {
        this.addnewEquipments();
        let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
        this.newEquipment = [
          {
            projectactid: maxPMEId + 1,
            actid: "",
            activities: "",
            projectPMEId: maxPMEId + 1,
            pmeId: "",
            pme: "",
            timePercent: 100,
            quantity: 1,
            noisePower: "",
            defaultNoisePower: 0,
            startDate: null,
            endDate: null,
            timePeriod: 1,
            location: "Notional Source",
            zone: this.selectedZone.id,
            group: this.selectedGroup,
            task: this.selectedTask,
            isqpme: false,
            isqcm: false,
            supportMaterials: [],
            exclusiveGroup: this.selectedExclusiveGroup,
          },
        ];
      }
      this.showRequiredPMEDialog = false;
    },
    addnewEquipments() {
      let props = this;
      if (this.selectedExclusiveGroup != "" && !this.exclusiveGroups.includes(this.selectedExclusiveGroup)) {
        this.exclusiveGroups.push(this.selectedExclusiveGroup);
        this.exclusiveGroups.sort();
      }
      // if (this.selectedExclusiveGroup != "") {
      //     this.project.equipments.filter(e =>
      //         e.zone == this.selectedZone.id && e.group == this.selectedGroup && e.task == this.selectedTask && e.exclusiveGroup == ""
      //     ).forEach(e => { e.exclusiveGroup = this.selectedExclusiveGroup })
      // }
      let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
      this.selectedPMEs.forEach((e) => {
        props.project.equipments.push({
          projectactid: maxPMEId + 1,
          actid: "",
          activities: "",
          projectPMEId: maxPMEId + 1,
          pmeId: "",
          pme: e.pme,
          timePercent: 100,
          quantity: 1,
          noisePower: e.noisePower,
          defaultNoisePower: e.noisePower,
          noisePowerMin: e.noisePowerMin,
          noisePowerMax: e.noisePowerMax,
          percentMin: e.percentMin,
          startDate: new Date(this.selectedTaskObject.start),
          endDate: new Date(this.selectedTaskObject.end),
          timePeriod: 1,
          location: "Notional Source",
          zone: this.selectedZone.id,
          group: this.selectedGroup,
          task: this.selectedTask,
          isqpme: false,
          isqcm: false,
          supportMaterials: [],
          exclusiveGroup: this.selectedExclusiveGroup,
        });
        maxPMEId += 1;
      });
      this.selectedQPMEs.forEach((e) => {
        props.project.equipments.push({
          projectactid: maxPMEId + 1,
          actid: "",
          activities: "",
          projectPMEId: maxPMEId + 1,
          pmeId: "",
          pme: e.pme,
          timePercent: 100,
          quantity: 1,
          noisePower: e.noisePower,
          defaultNoisePower: e.noisePower,
          noisePowerMin: e.noisePowerMin,
          noisePowerMax: e.noisePowerMax,
          percentMin: e.percentMin,
          startDate: new Date(this.selectedTaskObject.start),
          endDate: new Date(this.selectedTaskObject.end),
          timePeriod: 1,
          location: "Notional Source",
          zone: this.selectedZone.id,
          group: this.selectedGroup,
          task: this.selectedTask,
          isqpme: e.isqpme,
          isqcm: e.isqcm,
          supportMaterials: [],
          exclusiveGroup: this.selectedExclusiveGroup,
        });
        maxPMEId += 1;
      });
      this.updateTaskTreeStatus({
        zone: this.selectedZone.id,
        group: this.selectedGroup,
        task: this.selectedTask,
      });
      this.filterEquipment();
      this.showEquipmentList = false;
      this.selectedPMEs = [];
      this.selectedQPMEs = [];
      this.searchPME = "";
      this.search();
    },
    importEquipment() {
      let props = this;
      if (this.selectedExclusiveGroup != "" && !this.exclusiveGroups.includes(this.selectedExclusiveGroup)) {
        this.exclusiveGroups.push(this.selectedExclusiveGroup);
        this.exclusiveGroups.sort();
      }
      if (this.selectedExclusiveGroup != "" && this.selectedExclusiveGroup != "Without Exclusive Group - included in all groups") {
        this.project.equipments
          .filter((e) => e.zone == this.selectedZone.id && e.group == this.selectedGroup && e.task == this.selectedTask && e.exclusiveGroup == "")
          .forEach((e) => {
            e.exclusiveGroup = this.selectedExclusiveGroup;
          });
      }
      let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
      this.selectedActivity.equipments.forEach((equipment) => {
        props.project.equipments.push({
          projectactid: maxPMEId + 1,
          actid: "",
          activities: "",
          projectPMEId: maxPMEId + 1,
          pmeId: "",
          pme: equipment.pme,
          timePercent: 100,
          quantity: 1,
          noisePower: equipment.noisePower,
          defaultNoisePower: equipment.noisePower,
          noisePowerMin: equipment.noisePowerMin,
          noisePowerMax: equipment.noisePowerMax,
          percentMin: equipment.percentMin,
          startDate: new Date(this.selectedTaskObject.start),
          endDate: new Date(this.selectedTaskObject.end),
          timePeriod: 1,
          location: "Notional Source",
          zone: this.selectedZone.id,
          group: this.selectedGroup,
          task: this.selectedTask,
          isqpme: equipment.isqpme,
          isqcm: equipment.isqcm,
          supportMaterials: [],
          exclusiveGroup: this.selectedExclusiveGroup,
        });
        maxPMEId += 1;
      });
      this.updateTaskTreeStatus({
        zone: this.selectedZone.id,
        group: this.selectedGroup,
        task: this.selectedTask,
      });
      this.filterEquipment();
    },
    importEquipmentFromActivity() {
      let props = this;
      let equipments = this.project.equipments.filter((e) => e.task == this.selectedZoneActivity.id);
      let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
      equipments.forEach((e) => {
        props.project.equipments.push({
          ...e,
          id_0: undefined,
          zone: props.selectedZone.id,
          group: props.selectedGroup,
          task: props.selectedTask,
          projectPMEId: maxPMEId + 1,
          projectactid: maxPMEId + 1,
          startDate: new Date(props.selectedTaskObject.start),
          endDate: new Date(props.selectedTaskObject.end),
        });
        maxPMEId += 1;
      });
      this.updateTaskTreeStatus({
        zone: this.selectedZone.id,
        group: this.selectedGroup,
        task: this.selectedTask,
      });
      this.filterEquipment();
    },
    confirmOverwriteEquipment(event) {
      let props = this;
      this.$confirm.require({
        target: event.currentTarget,
        message: `Do you want to overwrite existing equipments in selected ${props.selectedZoneActivities.length} activities?`,
        icon: "pi pi-info-circle",
        accept: () => {
          props.copyEquipmentToActivities(true);
        },
        reject: () => {
          props.copyEquipmentToActivities(false);
        },
      });
    },
    copyEquipmentToActivities(overwrite) {
      let props = this;
      let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
      this.selectedZoneActivities.forEach((t) => {
        console.log(t.id);
        if (t.id == props.selectedTask) {
          console.log("current");
          return;
        }
        console.log(t.id);
        if (overwrite) {
          let equipments = props.project.equipments.filter((e) => e.task == t.id);
          props.project.equipments = props.project.equipments.filter((e) => e.task != t.id);
          equipments.forEach((e) => {
            if (e.id_0) {
              props.axios
                .delete(`${props.apiEndpoint}projectpme/${e.id_0}`)
                .then(function (response) {
                  console.log(response);
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          });
        }
        props.filteredEquipments.forEach((e) => {
          props.project.equipments.push({
            ...e,
            id_0: undefined,
            zone: t.zone,
            group: t.group,
            task: t.id,
            projectPMEId: maxPMEId + 1,
            projectactid: maxPMEId + 1,
            startDate: new Date(t.start),
            endDate: new Date(t.end),
          });
          maxPMEId += 1;
        });
        props.updateTaskTreeStatus({
          zone: t.zone,
          group: t.group,
          task: t.id,
        });
      });
      this.selectedZoneActivities = [];
    },
    deleteEquipment(equipment) {
      let props = this;
      let index = this.project.equipments.indexOf(equipment);
      if (index > -1 && equipment.id_0) {
        props.axios
          .delete(`${props.apiEndpoint}projectpme/${equipment.id_0}`)
          .then(function (response) {
            console.log(response);
            props.project.equipments.splice(index, 1);
            props.filterEquipment();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        props.project.equipments.splice(index, 1);
        props.filterEquipment();
      }
      this.updateTaskTreeStatus(equipment);
    },
    initCWActPMEs(callback) {
      let props = this;
      this.axios.get(`${this.apiEndpoint}cwactpme?type=construction`).then((response) => {
        props.constructionWorks = response.data;
        props.constructionWorks.forEach((cw) => {
          cw.equipments.forEach((e) => {
            e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
          });
        });
        props.axios.get(`${this.apiEndpoint}cwactpme?type=activities`).then((response) => {
          props.activities = response.data;
          props.activities.forEach((ac) => {
            ac.equipments.forEach((e) => {
              e.pme = e.officialId != "" ? `${e.officialId} - ${e.name}` : e.name;
            });
          });
          callback();
        });
      });
    },
    search() {
      if (this.searchPME != "") {
        this.searchedPMEs = this.pmes.filter((e) => !e.isQPME && !e.isQCM && e.pme.toLowerCase().includes(this.searchPME.toLowerCase()));
        this.searchedQPMEs = this.pmes.filter((e) => e.isQPME && e.pme.toLowerCase().includes(this.searchPME.toLowerCase()));
      } else {
        this.searchedPMEs = this.pmes.filter((e) => !e.isQPME && !e.isQCM);
        this.searchedQPMEs = this.pmes.filter((e) => e.isQPME);
      }
    },
    searchAutoCompletePME(event) {
      if (!event.query.trim().length) {
        this.filteredPMEs = [...this.pmes.map((e) => e.pme)];
      } else {
        this.filteredPMEs = this.pmes
          .map((e) => e.pme)
          .filter((e) => {
            return e.toLowerCase().includes(event.query.toLowerCase());
          });
      }
    },
    selectAutoCompletePME(event) {
      let equipment = this.pmes.filter((e) => e.pme == event.value)[0];
      if (equipment.required1.length > 0) {
        this.setCurrentSelect(equipment);
        this.fromAutoComplete = true;
        this.showRequiredPMEDialog = true;
      } else {
        let maxPMEId = this.project.equipments.length == 0 ? 0 : Math.max(...this.project.equipments.map((e) => parseInt(e.projectPMEId)));
        let newEquipment = {
          ...equipment,
          projectactid: maxPMEId + 1,
          actid: "",
          activities: "",
          projectPMEId: maxPMEId + 1,
          timePercent: 100,
          quantity: 1,
          defaultNoisePower: equipment.noisePower,
          startDate: new Date(this.selectedTaskObject.start),
          endDate: new Date(this.selectedTaskObject.end),
          timePeriod: 1,
          location: "Notional Source",
          zone: this.selectedZone.id,
          group: this.selectedGroup,
          task: this.selectedTask,
          supportMaterials: [],
          exclusiveGroup: this.selectedExclusiveGroup,
        };
        this.newEquipment = [newEquipment];
      }
    },
    changeExclusiveGroup() {
      if (!this.exclusiveGroups.includes(this.selectedExclusiveGroup)) {
        this.exclusiveGroups.push(this.selectedExclusiveGroup);
        this.exclusiveGroups.sort();
      }
      this.selectedEquipments.forEach((e) => {
        e.exclusiveGroup = this.selectedExclusiveGroup == "Without Exclusive Group - included in all groups" ? "" : this.selectedExclusiveGroup;
      });
      this.selectedEquipments = [];
      this.filterEquipment();
    },
    downloadTemplate() {
      let lines = [
        "# Instruction to use this template",
        `"1. To use PME, fill in CNP number, for example, fill in 'CNP 004' in Equipment column if you would like to use 'CNP 004 - Asphalt paver'. You may reference to CNMP Equipment List for available CNP numbers."`,
        "2. Leave Sound Power column blank to use default sound power.",
        "3. Leave Start Date and End Date column blank to use default task duration for your equipment.",
        "",
        "Equipment,Quantity,Sound Power,Start Date,End Date,% on Time in 30 mins",
      ];
      // this.filteredEquipments.forEach(e => {
      //     const line = [];
      //     line.push(`"${e.pme}"`)
      //     line.push(e.quantity)
      //     line.push(e.defaultNoisePower)
      //     line.push(e.startDate.toISOString().split('T')[0])
      //     line.push(e.endDate.toISOString().split('T')[0])
      //     line.push(e.timePeriod * 100)
      //     lines.push(line.join(","))
      // })
      let csvFile = new Blob([lines.join("\n")], { type: "text/csv" });
      var link = document.createElement("a");
      link.target = "_blank";
      link.download = "Equipment.csv";
      link.href = window.URL.createObjectURL(csvFile);
      link.click();
      link.remove();
    },
    importTemplate(files) {
      let props = this;
      let csv = files[0];
      if (csv.type == "text/csv") {
        var reader = new FileReader();
        reader.readAsText(csv, "UTF-8");
        reader.onload = function () {
          // Remove UTF-8 BOM if present
          let csvText = reader.result;
          if (csvText.charCodeAt(0) === 0xfeff) {
            csvText = csvText.slice(1);
          }

          var lines = csvText.split("\n");
          // Skip first 5 lines (0-4), headers are at line 6 (index 5), data starts at line 7 (index 6)
          var headerLine = lines[5];
          var dataLines = lines.slice(6).join("\n");

          // Parse with Papa Parse
          const csvData = Papa.parse(headerLine + "\n" + dataLines, {
            header: true,
            skipEmptyLines: true,
            dynamicTyping: false,
          });

          const rows = csvData.data;
          const headers = Object.keys(rows[0] || {});

          let equipmentIndex = headers.findIndex((h) => h.toLowerCase().includes("equipment"));
          let quantityIndex = headers.findIndex((h) => h.toLowerCase().includes("quantity"));
          let soundPowerIndex = headers.findIndex((h) => h.toLowerCase().includes("sound power"));
          let startIndex = headers.findIndex((h) => h.toLowerCase().includes("start"));
          let endIndex = headers.findIndex((h) => h.toLowerCase().includes("end"));
          let timeIndex = headers.findIndex((h) => h.toLowerCase().includes("time"));

          let equipmentKey = equipmentIndex >= 0 ? headers[equipmentIndex] : null;
          let quantityKey = quantityIndex >= 0 ? headers[quantityIndex] : null;
          let soundPowerKey = soundPowerIndex >= 0 ? headers[soundPowerIndex] : null;
          let startKey = startIndex >= 0 ? headers[startIndex] : null;
          let endKey = endIndex >= 0 ? headers[endIndex] : null;
          let timeKey = timeIndex >= 0 ? headers[timeIndex] : null;

          for (var i = 0; i < rows.length; i++) {
            let row = rows[i];
            let newData = Object.values(row);
            if (newData.filter((element) => element).length == 0) continue;

            if (
              row[startKey] &&
              (isNaN(Date.parse(row[startKey])) || Date.parse(row[startKey]) < 0 || DateHelper.getDateString(Date.parse(row[startKey])) == null)
            ) {
              window.alert(`Invalid date format found in your csv: ${row[startKey]}`);
              break;
            }
            if (
              row[endKey] &&
              (isNaN(Date.parse(row[endKey])) || Date.parse(row[endKey]) < 0 || DateHelper.getDateString(Date.parse(row[endKey])) == null)
            ) {
              window.alert(`Invalid date format found in your csv: ${row[endKey]}`);
              break;
            }
            if (row[startKey] && row[endKey] && Date.parse(row[startKey]) > Date.parse(row[endKey])) {
              window.alert(`End date is earlier than start date: ${row[startKey]} - ${row[endKey]}`);
              break;
            }
            if (Number.parseFloat(row[timeKey]) > 100 || Number.parseFloat(row[timeKey]) < 0) {
              window.alert(`Invalid % on time in 30 mins: ${row[timeKey]}`);
              break;
            }
            let targetEquipment = props.pmes.filter((e) => e.pme?.startsWith(row[equipmentKey]));
            console.log("row", row);
            console.log("props.project.equipments", props.project.equipments);
            let existingEquipment = props.project.equipments.filter(
              (e) =>
                e.pme.startsWith(row[equipmentKey]) &&
                e.timePercent === Number.parseFloat(row[timeKey]) &&
                e.exclusiveGroup === props.selectedExclusiveGroup &&
                DateHelper.getDateString(e.startDate) === DateHelper.getDateString(new Date(row[startKey])) &&
                DateHelper.getDateString(e.endDate) === DateHelper.getDateString(new Date(row[endKey])),
            );
            if (existingEquipment.length) {
              existingEquipment[0].quantity += Number.parseInt(row[quantityKey]);
            } else {
              let equipment = {};
              if (targetEquipment.length) {
                equipment = targetEquipment[0];
              }
              let maxPMEId = props.project.equipments.length == 0 ? 0 : Math.max(...props.project.equipments.map((e) => parseInt(e.projectPMEId)));
              let newEquipment = {
                projectactid: maxPMEId + 1,
                actid: "",
                activities: "",
                projectPMEId: maxPMEId + 1,
                pme: row[equipmentKey],
                timePercent: row[timeKey],
                quantity: row[quantityKey],
                defaultNoisePower: row[soundPowerKey] || 0,
                noisePower: row[soundPowerKey] || 0,
                startDate: row[startKey] ? new Date(row[startKey]) : new Date(props.selectedTaskObject.start),
                endDate: row[endKey] ? new Date(row[endKey]) : new Date(props.selectedTaskObject.end),
                timePeriod: 1,
                location: "Notional Source",
                zone: props.selectedZone.id,
                group: props.selectedGroup,
                task: props.selectedTask,
                supportMaterials: [],
                exclusiveGroup: props.selectedExclusiveGroup,
                pmeId: "",
                isqpme: false,
                isqcm: false,
                ...equipment,
              };
              props.project.equipments.push(newEquipment);
            }
          }
          document.getElementById("uploadEquipment").value = "";
          props.filterEquipment();
        };
      }
    },
  },

  mounted() {
    this.initialEquipment = this.project.equipments.map((e) => {
      return { ...e };
    });
    console.log(this.initialEquipment);
    this.initEquipments();
    this.initCWActPMEs(this.initActivityOptions);
    this.initTaskTree();
    this.selectedZone = this.project.zones[0];
    this.filterEquipment();
    this.exclusiveGroups = [
      "Without Exclusive Group - included in all groups",
      ...new Set(this.project.equipments.filter((e) => e.exclusiveGroup != "").map((e) => e.exclusiveGroup)),
    ];
    this.exclusiveGroups.sort();
    document.querySelector("#pmeList > div > ul").classList.add("formgrid");
    document.querySelector("#pmeList > div > ul").classList.add("grid");
    document.querySelectorAll("#pmeList > div > ul > li.p-listbox-item").forEach((li) => {
      li.classList.add("col-12");
      li.classList.add("md:col-4");
    });
    // document.querySelector("#qpmeList > div > ul").classList.add("formgrid");
    // document.querySelector("#qpmeList > div > ul").classList.add("grid");
    // document.querySelectorAll("#qpmeList > div > ul > li.p-listbox-item").forEach(li => {
    //     li.classList.add("col-12");
    //     li.classList.add("md:col-4");
    // });
    MapOL.showPMEInitActions();
    if (!this.project.readonly) {
      this.project.equipments.forEach((e) => {
        e.startDate = DateHelper.getDate(e.startDate);
        e.endDate = DateHelper.getDate(e.endDate);
      });
    }
  },
};
</script>

<style lang="less">
.p-inputnumber .p-inputnumber-input {
  width: 80%;
}

.ddEquipment {
  width: 250px;
}

#equipmentInput .p-datatable .p-datatable-tbody > tr > td {
  padding: 0 0.5rem !important;
  font-size: 12px;
}

.p-dropdown-label {
  font-size: 12px !important;
}

.p-dropdown-item {
  font-size: 12px !important;
}

#equipmentInput > div > table {
  width: 100%;
}

.inputnumber > input {
  font-size: 12px;
}

.p-multiselect-label {
  font-size: 12px;
}

.p-multiselect-item > span {
  font-size: 12px;
}

.p-frozen-column {
  z-index: 2;
}

.p-datatable-thead {
  z-index: 3 !important;
}

tbody.p-datatable-tbody.p-datatable-frozen-tbody {
  z-index: 4 !important;
}

.p-menuitem-text {
  text-align: left;
}

// .p-panelmenu-icon {
//     order: 1; // to be the first item on right side.
// }

.p-menuitem-icon {
  order: 1; // to be the first item on right side.
  margin-left: 5px;
}

#taskTree .p-menuitem-icon.pi.pi-check {
  color: green !important;
}

.p-menuitem-text {
  flex-grow: 1; // to fill the whole space and push the icon to the end
}

.p-tooltip {
  width: auto !important;
  max-width: 400px !important;
}

#pmeList .p-listbox-item {
  flex: 0 0 auto;
  width: 33.3333%;
  padding-top: 0;
  padding-bottom: 0;
}

#qpmeList .p-listbox-item {
  flex: 00 auto;
  width: 33.3333%;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<style scoped>
.card {
  height: 85vh;
  width: 95vw;
  position: absolute;
  transform: translate(4%, 2%);
}

.upload {
  height: 30vh;
  width: 40vw;
  position: absolute;
  transform: translate(80%, 50%);
}

.inputnumber {
  margin: 5px 0;
  height: 30px;
  width: 100px;
}
</style>
